var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "rounded",
          attrs: { data: _vm.data, align: "center", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", width: "80", prop: "id", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("div", {}, [_vm._v(_vm._s(scope.row.id))])
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Documento", width: "150", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            scope.row.tipo === "J"
                              ? _vm.formatCNPJ(scope.row.documento)
                              : _vm.formatCPF(scope.row.documento)
                          ) +
                          "\n                "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Tipo", width: "130", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.tipo === "J" ? "P. Jurídica" : "P. Física"
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Status", width: "130", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.status
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "small",
                              type:
                                scope.row.status === "APROVADO"
                                  ? "success"
                                  : "danger"
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(scope.row.status.toUpperCase()) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Consultado por",
              "min-width": "250",
              align: "left"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.feito_por
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            style: { gap: "8px" }
                          },
                          [
                            _c("el-avatar", { attrs: { size: "small" } }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(scope.row.feito_por.name.charAt(0)) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex flex-column",
                                style: { minWidth: 0, flex: 1 }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-weight-bold text-truncate",
                                    style: { fontSize: "14px" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(scope.row.feito_por.name) +
                                        "\n                      "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [
                            _vm._v(
                              "\n                    Não associado\n                  "
                            )
                          ]
                        )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Criado em", width: "180", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(scope.row.created_at, true))
                        )
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.isAuthorized
            ? _c(
                "el-table-column",
                {
                  attrs: { fixed: "right", align: "right", width: "75" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "mini",
                                  type: "primary",
                                  plain: "",
                                  title: "Ver detalhes"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.dispatchSPCConsulta(scope.row.id)
                                  }
                                },
                                slot: "reference"
                              },
                              [
                                _c("i", { staticClass: "el-icon-right" }),
                                _vm._v(" "),
                                _c("i", { staticClass: "el-icon-notebook-2" })
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3614673477
                  )
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("i", { staticClass: "el-icon-menu" })]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "template",
            { slot: "empty" },
            [
              _c("el-empty", {
                attrs: { description: "Nenhuma consulta disponível" }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt-3" },
        [
          _c(
            "el-col",
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.data.currentPage,
                  "page-sizes": _vm.pagination.pageSizes,
                  "page-size": _vm.pagination.data.perPage,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.pagination.total
                },
                on: {
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pagination.data, "currentPage", $event)
                  },
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("SPCShowModal", { ref: "spcConsultaShow", on: { updated: _vm.fetch } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12d0d520", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d0d520","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/spc/SPCList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-12d0d520","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/spc/SPCList.vue
// module chunks = 2